(function ($, window, document) {

function onDOMContentLoaded() {

  $('.free-content.terms table').addClass('table')
    .wrap($('<div />').css({'overflow-x': 'scroll'})); // table overflow breaks /autovakuutus
  
  $('.free-content a.back').on('click', function (e) {
    e.preventDefault();
    window.history.back();
  });

  var session = false;
  try {
    session = window.sessionStorage.getItem('session');
  } catch (e) {
    // We don't have sessionStorage and assume the user is new
  }

  if (!session) {
    $('.free-content a.back').hide();
    try {
      window.sessionStorage.setItem('session', new Date().getTime());
    } catch (e) {
      // We don't have sessionStorage so the user will remain new
    }
  }
}
if (document.readyState == 'loading') {
  document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
} else {
  onDOMContentLoaded();
}

})(jQuery, window, document);
